module.exports = __webpack_public_path__ + "static/media/4_formysilikonowe.9b297bea.png";